module.exports = __webpack_public_path__ + "img/exchange.db1c1dd1.svg";